import React from 'react';
// logic
import useFilterViewsList from '../components/filterViewsList/useFilterViewsList';
// components
import PortalContent from '../components/ui/portal/portalContent';
import FilterViewsListToolbar from '../components/filterViewsList/filterViewsListToolbar';
import FilterViewsList from '../components/filterViewsList/filterViewsList';

const FilterViewsListPage = () => {
  const filterViewsListData = useFilterViewsList();

  return (
    <>
      <PortalContent>
        <FilterViewsListToolbar />
      </PortalContent>
      <FilterViewsList filterViewsListData={filterViewsListData} />
    </>
  );
};

export default FilterViewsListPage;
